import QueryService from "../utils/QueryService.ts";

class AutomotiveService {
	queryService = new QueryService("/automotive_generations/");

	getReflectionLayers = async (imageUrl: string | undefined, masks: Record<string, string>): Promise<any> => {
		const response = await this.queryService.post("generate_reflections", {
			image_url: imageUrl,
			layers: true,
			masks: masks,
		});
		return response;
	};

	getTiersLayers = async (imageUrl: string | undefined, masks: Record<string, string>): Promise<any> => {
		const response = await this.queryService.post("refine_tires", {
			image_url: imageUrl,
			layers: true,
			masks: masks,
		});
		return response;
	};

	generateSegmentation = async (imageUrl: string | undefined): Promise<any> => {
		const response = await this.queryService.post("generate_segments", {
			image_url: imageUrl,
		});
		return response;
	};

	uploadSegmentation = async (segment: File): Promise<string> => {
		const formData = new FormData();
		formData.append("file", segment);
		const response = await this.queryService.post("upload_segment", formData, {
			"Content-Type": "multipart/form-data",
		});
		return response;
	};
}

export default AutomotiveService;
